function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-8.092 -9.463)"
}, React.createElement("rect", {
  width: 32.704,
  height: 31.536,
  rx: 4,
  transform: "translate(8.092 9.463)",
  fill: "#ff2700"
}), React.createElement("path", {
  d: "M20.083,18.341V28.793a3.116,3.116,0,0,0-1.885-.628,3.2,3.2,0,0,0,0,6.4,3.145,3.145,0,0,0,3.141-3.2V23.138l9.538-3.37v7.082a3.142,3.142,0,0,0-5.026,2.57,3.17,3.17,0,1,0,6.34,0V14Z",
  fill: "#fff"
}));

var SvgInGameMusic = function SvgInGameMusic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 32.704,
    height: 31.536,
    viewBox: "0 0 32.704 31.536",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInGameMusic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/in-game-music.28d2e2a3.svg";
export { ForwardRef as ReactComponent };